import { useEventCallback } from 'usehooks-ts'

import { contactsLinks } from '@wwt/shared/config'

// TODO: implement actual share functions
export const useShare = () => {
	const handleMessengerShare = useEventCallback(() => {
		window.open(contactsLinks.messenger, '_blank', 'noopener,noreferrer')
	})

	const handleInstagramShare = useEventCallback(() => {
		window.open(contactsLinks.instagram, '_blank', 'noopener,noreferrer')
	})

	const handleWhatsappShare = useEventCallback(() => {
		window.open(contactsLinks.whatsapp, '_blank', 'noopener,noreferrer')
	})

	const handleFacebookShare = useEventCallback(() => {
		window.open(contactsLinks.facebook, '_blank', 'noopener,noreferrer')
	})

	return {
		handleMessengerShare,
		handleInstagramShare,
		handleWhatsappShare,
		handleFacebookShare
	}
}
